/**
 * 等级配置页面
 */
import './vip.css';
import React, {Component} from 'react';

class VIP extends Component{
    static defaultProps = {
        value: 0
    }

    constructor(props){
        super(props);
        
        this.state = {
            value: props.value
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        })   
    }
    
    render() {
        return <i className="ui-vip" data-vip={this.state.value}></i>;
    }
}

export default VIP;



// WEBPACK FOOTER //
// ./js/component/user-ui/vip.js